import * as React from 'react';
import "./helpInfo.less";
import { useState, useEffect } from 'react';
import { currencyFormat } from '../../helpers';
import { PricePerUnitRate } from '../../data/dataStore';

// declare var GSheetReader: any;

export interface HelpInfoProps {
    rates: PricePerUnitRate;
}

export const HelpInfo = (props: HelpInfoProps) => {

    const [show, setShow] = useState(false);

    const { rates } = props;


    return <div className="help-info-wrap">
        {!show &&
            <div className="about click" onClick={() => setShow(true)}>About</div>
        }
        {show &&
            <div className="help-info">
                <p>
                    <span className="head">WHAT IS THIS?</span>
                    It's a tool to help you answer the eternal question, "what do I need to sell or stream to cover my release costs?" … or …. "What is my ProfitPoint?"
                </p>
                <p>
                    <span className="head">HOW DO I USE IT?</span>
                    Enter a few details about your release and your expenses, and the tool will give you sales targets across a range of format types.
                </p>
                <p>
                    <span className="head">THOSE TARGETS LOOK WAY OUT OF WHACK!</span>
                    Does the streaming target look a bit too high? No way that you'll sell that many albums? Drag the sliders around to change the sales mix and we'll automagically adjust the other formats so you always hit your ProfitPoint. Play around till you get a good, achievable set of targets for your release.
                </p>
                <p>
                    <span className="head">WHAT ARE YOU BASING THESE NUMBERS ON?</span>
                    We've based all our figures on the real artist income that we've reviewed and analysed over the last few years. There's no way to predict the future and the "price per unit" for streams and sales is constantly in flux, but this should hopefully get you off to a good start. The price per unit for each format is:
                </p>
                {/* note: need all the decimal places so don't display as money */}
                <ul>
                    <li>AU${rates.cdAlbumPrice} – CD</li>
                    <li>AU${rates.vinylAlbumPrice} – LP</li>
                    <li>AU${rates.digitalAlbumPrice} – Album download</li>
                    <li>AU${rates.digitalTrackPrice} – Track Download</li>
                    <li>AU${rates.perStreamRate} – Stream</li>
                </ul>
                <p>
                    <br />
                    We will be updating these figures as we receive more data over time.
                </p>
                <p>
                    <span className="head">ANYTHING ELSE?</span>
                    Yeah, just that this is a fun little tool and not meant to produce rock solid figures for your budget. Have a play around to get some rough ideas but always feel free to get in touch with us directly if you want to get into some real number crunching!.
                </p>
                <p>
                    <span className="head">HIT US UP</span>
                    <a href="mailto:info@whitesky.com.au">info@whitesky.com.au</a>
                </p>
            </div>
        }
    </div>

}